import { render, staticRenderFns } from "./item-number-dobule.vue?vue&type=template&id=e921c52e"
import script from "./item-number-dobule.vue?vue&type=script&lang=js"
export * from "./item-number-dobule.vue?vue&type=script&lang=js"
import style0 from "./item-number-dobule.vue?vue&type=style&index=0&id=e921c52e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.23_cache-loader@4.1.0_webpack@4.47.0_webpack-cli@3.3_rzr6sqiw3iaxcjpfollk37er5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports